(() => {
  const joySelector = '.Avada-Joy_ButtonWidget';
  const chatHostSelectors = ['#ShopifyChat', 'shopify-chat'];
  const chatActivatorSelectors = [
    'button[part="activator"]',
    '.activator',
    '.activator-nudge'
  ];
  const observedRoots = new WeakSet();
  let frameId = null;
  const layoutStyleId = 'aumpex-floating-layout-style';
  const injectLayoutStyles = () => {
    if (document.getElementById(layoutStyleId)) return;
    const style = document.createElement('style');
    style.id = layoutStyleId;
    style.textContent = `
      @media (max-width: 749px) {
        .Avada-Joy_ButtonWidget {
          left: 16px !important; right: auto !important;
          bottom: calc(var(--aumpex-sticky-atc-height, 72px) + env(safe-area-inset-bottom) + 14px) !important;
          z-index: 71 !important;
        }
        #ShopifyChat, shopify-chat {
          bottom: calc(var(--aumpex-sticky-atc-height, 72px) + env(safe-area-inset-bottom) + 14px) !important;
          z-index: 72 !important;
        }
        .needsclick[role="dialog"][aria-label*="Form"], .needsclick[role="dialog"] {
          box-sizing: border-box !important; max-width: min(400px, calc(100vw - 32px)) !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const getVisibleRect = (element) => {
    if (!element) return null;

    const rect = element.getBoundingClientRect();
    const style = window.getComputedStyle(element);
    const isVisible =
      rect.width > 0 &&
      rect.height > 0 &&
      rect.bottom > 0 &&
      rect.top < window.innerHeight &&
      style.display !== 'none' &&
      style.visibility !== 'hidden';

    return isVisible ? rect : null;
  };

  const getChatButton = () => {
    for (const hostSelector of chatHostSelectors) {
      const host = document.querySelector(hostSelector);
      if (!host) continue;

      const roots = [host.shadowRoot, host].filter(Boolean);

      for (const root of roots) {
        for (const activatorSelector of chatActivatorSelectors) {
          const activator = root.querySelector(activatorSelector);
          if (getVisibleRect(activator)) return activator;
        }
      }
    }

    return null;
  };

  const observeChatRoot = () => {
    for (const hostSelector of chatHostSelectors) {
      const host = document.querySelector(hostSelector);
      const root = host?.shadowRoot;

      if (!root || observedRoots.has(root)) continue;

      observer.observe(root, {
        childList: true,
        subtree: true,
        attributes: true
      });
      observedRoots.add(root);
    }
  };

  const alignJoyWithChat = () => {
    injectLayoutStyles();
    observeChatRoot();

    const joyButton = document.querySelector(joySelector);
    const chatButton = getChatButton();

    if (!joyButton) return;
    if (!chatButton) {
      joyButton.style.setProperty('bottom', 'calc(var(--aumpex-sticky-atc-height, 72px) + env(safe-area-inset-bottom) + 14px)', 'important');
      return;
    }

    const joyRect = getVisibleRect(joyButton);
    const chatRect = getVisibleRect(chatButton);

    if (!joyRect || !chatRect) return;

    const chatCenterFromBottom =
      window.innerHeight - (chatRect.top + chatRect.height / 2);
    const joyBottom = Math.max(0, chatCenterFromBottom - joyRect.height / 2);
    const nextBottom = `${Math.round(joyBottom)}px`;

    if (
      joyButton.style.getPropertyValue('bottom') !== nextBottom ||
      joyButton.style.getPropertyPriority('bottom') !== 'important'
    ) {
      joyButton.style.setProperty('bottom', nextBottom, 'important');
    }
  };

  const scheduleAlign = () => {
    if (frameId) return;

    frameId = window.requestAnimationFrame(() => {
      frameId = null;
      alignJoyWithChat();
    });
  };

  let observer;
  const initAlignment = () => {
    observer = new MutationObserver(scheduleAlign);
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.addEventListener('resize', scheduleAlign);
    window.addEventListener('orientationchange', scheduleAlign);
    scheduleAlign();
  };
  const scheduleIdleAlignment = () => {
    if (window.requestIdleCallback) window.requestIdleCallback(initAlignment, { timeout: 2000 });
    else window.setTimeout(initAlignment, 0);
  };
  if (document.readyState === 'complete') scheduleIdleAlignment();
  else window.addEventListener('load', scheduleIdleAlignment, { once: true });
})();

// Keep the third-party WSATC layer from covering the cart drawer or returning on PDP.
(() => {
  const wsatcSelector = '.wsatc-add-to-cart-container';
  const applyWsatcState = () => {
    const isProductPage = [...document.body.classList].some((name) => name === 'template-product' || name.startsWith('template-product-'));
    const drawerOpen = document.body.classList.contains('page-overlay-cart-on');
    document.querySelectorAll(wsatcSelector).forEach((element) => {
      if (isProductPage || drawerOpen) {
        element.style.setProperty('display', 'none', 'important');
        element.style.setProperty('visibility', 'hidden', 'important');
        element.style.setProperty('pointer-events', 'none', 'important');
      }
    });
  };

  const observer = new MutationObserver(applyWsatcState);
  observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  document.addEventListener('cart-drawer:open', applyWsatcState);
  document.addEventListener('cart-drawer:close', applyWsatcState);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyWsatcState, { once: true });
  } else {
    applyWsatcState();
  }
})();

(() => {
  if (document.body?.classList.contains('template-index')) return;
  const hiddenClass = 'aumpex-klaviyo-scroll-hidden';
  const styleId = 'aumpex-klaviyo-scroll-visibility-style';
  const productDetailsSelector =
    'collapsible-section[data-block-id="collapsible_tab_HaQtLa"]';
  const triggerThreshold = 120;
  const klaviyoSelectors = [
    '.needsclick[role="dialog"][aria-label*="Form"]',
    '.needsclick[role="dialog"]'
  ];
  const klaviyoTextPattern = /(get\s*)?\$?\s*20\s*off|20\s*off|first\s+order/i;
  let productDetails = null;
  let shouldHideKlaviyo = false;
  let detailsObserver = null;
  let detailsBoundary = null;
  let resizeFrameId = null;
  let mutationFrameId = null;
  let visibilityFrameId = null;

  const injectStyles = () => {
    if (document.getElementById(styleId)) return;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      .${hiddenClass} {
        opacity: 0 !important;
        visibility: hidden !important;
        pointer-events: none !important;
        transform: translateY(110%) !important;
        transition:
          opacity 240ms ease,
          visibility 240ms ease,
          transform 240ms ease !important;
      }
    `;
    document.head.appendChild(style);
  };

  const findProductDetails = () => {
    const directMatch = document.querySelector(productDetailsSelector);
    if (directMatch) return directMatch;

    return Array.from(document.querySelectorAll('collapsible-section.wt-collapse')).find(
      (section) => {
        const title = section
          .querySelector('.wt-collapse__trigger__title')
          ?.textContent?.trim();

        return title === 'Product Details';
      }
    );
  };

  const getVisibleRect = (element) => {
    if (!element) return null;

    const rect = element.getBoundingClientRect();
    const style = window.getComputedStyle(element);

    if (
      rect.width <= 0 ||
      rect.height <= 0 ||
      style.display === 'none' ||
      style.visibility === 'hidden'
    ) {
      return null;
    }

    return rect;
  };

  const getKlaviyoWrapper = (element) => {
    return (
      element.closest('.needsclick[role="dialog"][aria-label*="Form"]') ||
      element.closest('.needsclick[role="dialog"]') ||
      element.closest('.needsclick') ||
      element
    );
  };

  const findKlaviyoTargets = () => {
    const targets = new Set();

    document.querySelectorAll(`.${hiddenClass}`).forEach((element) => {
      targets.add(element);
    });

    klaviyoSelectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((element) => {
        const text = element.textContent || '';
        if (
          element.querySelector('.klaviyo-form') ||
          element.className?.toString().includes('kl-private-reset-css') ||
          klaviyoTextPattern.test(text)
        ) {
          targets.add(getKlaviyoWrapper(element));
        }
      });
    });

    document.querySelectorAll('.klaviyo-form, [class*="klaviyo-form"]').forEach((element) => {
      targets.add(getKlaviyoWrapper(element));
    });

    document.querySelectorAll('.needsclick').forEach((element) => {
      const text = element.textContent || '';
      const rect = getVisibleRect(element);

      if (rect && klaviyoTextPattern.test(text)) {
        targets.add(getKlaviyoWrapper(element));
      }
    });

    return Array.from(targets).filter(Boolean);
  };

  const hideKlaviyo = () => {
    findKlaviyoTargets().forEach((target) => {
      target.classList.add(hiddenClass);
    });
  };

  const showKlaviyo = () => {
    findKlaviyoTargets().forEach((target) => {
      target.classList.remove(hiddenClass);
    });
  };

  const applyKlaviyoState = () => {
    if (shouldHideKlaviyo) {
      hideKlaviyo();
    } else {
      showKlaviyo();
    }
  };

  const updateVisibility = () => {
    if (!productDetails) productDetails = findProductDetails();
    if (!productDetails) return;

    const rect = productDetails.getBoundingClientRect();
    shouldHideKlaviyo = rect.top <= triggerThreshold;
    applyKlaviyoState();
  };

  const scheduleVisibilityUpdate = () => {
    if (visibilityFrameId) return;

    visibilityFrameId = window.requestAnimationFrame(() => {
      visibilityFrameId = null;
      updateVisibility();
    });
  };

  const getDetailsBoundary = () => {
    if (!productDetails) productDetails = findProductDetails();
    if (!productDetails) return null;

    if (!detailsBoundary) {
      detailsBoundary = document.createElement('span');
      detailsBoundary.className = 'aumpex-klaviyo-scroll-boundary';
      detailsBoundary.setAttribute('aria-hidden', 'true');
      Object.assign(detailsBoundary.style, {
        display: 'block',
        width: '1px',
        height: '1px',
        margin: '0 0 -1px',
        padding: '0',
        border: '0',
        overflow: 'hidden',
        pointerEvents: 'none',
        opacity: '0'
      });
    }

    if (detailsBoundary.nextElementSibling !== productDetails) {
      productDetails.parentNode?.insertBefore(detailsBoundary, productDetails);
    }

    return detailsBoundary;
  };

  const createDetailsObserver = () => {
    if (!productDetails) productDetails = findProductDetails();
    if (!productDetails) return;

    if (detailsObserver) detailsObserver.disconnect();

    detailsObserver = new IntersectionObserver(scheduleVisibilityUpdate, {
      root: null,
      rootMargin: `-${triggerThreshold}px 0px 0px 0px`,
      threshold: 0
    });
    detailsObserver.observe(getDetailsBoundary());
    updateVisibility();
  };

  const scheduleMutationUpdate = () => {
    if (mutationFrameId) return;

    mutationFrameId = window.requestAnimationFrame(() => {
      mutationFrameId = null;
      applyKlaviyoState();

      if (
        !productDetails ||
        !detailsBoundary ||
        !document.documentElement.contains(detailsBoundary)
      ) {
        productDetails = findProductDetails();
        if (productDetails) createDetailsObserver();
      }
    });
  };

  const scheduleObserverRefresh = () => {
    if (resizeFrameId) return;

    resizeFrameId = window.requestAnimationFrame(() => {
      resizeFrameId = null;
      createDetailsObserver();
    });
  };

  const init = () => {
    injectStyles();
    productDetails = findProductDetails();
    createDetailsObserver();
    applyKlaviyoState();

    const mutationObserver = new MutationObserver(scheduleMutationUpdate);
    mutationObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    window.addEventListener('resize', scheduleObserverRefresh);
    window.addEventListener('orientationchange', scheduleObserverRefresh);
    window.addEventListener('scroll', scheduleVisibilityUpdate, { passive: true });

  };

  const scheduleIdleInit = () => {
    if (window.requestIdleCallback) window.requestIdleCallback(init, { timeout: 2000 });
    else window.setTimeout(init, 0);
  };
  if (document.readyState === 'complete') scheduleIdleInit();
  else window.addEventListener('load', scheduleIdleInit, { once: true });
})();
